<!-- Page Content -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="{{ 'payroll.workers-compensation.workersCompensation' | appTranslate }}"
        [menuService]="payrollModuleMenuService"
    >
        <div class="buttons">
            <ui-button *ngIf="!route.snapshot.data.isPayrollPending" type="primary" url="create">
                <mat-icon svgIcon="plus"></mat-icon>{{ 'payroll.workers-compensation.workersCompRate' | appTranslate }}
            </ui-button>
        </div>
    </app-header>

    <!-- Disabled Banner -->
    <ui-banner *ngIf="route.snapshot.data.isPayrollPending" class="margin-bottom-4" variant="warning">
        <p class="flag-content">{{ 'payroll.workers-compensation.pendingPayrollNotice' | appTranslate }}</p>
    </ui-banner>

    @if (shouldShowYearEndWarning) {
        <ui-banner class="margin-bottom-4" variant="info"
            ><div>
                <strong>{{
                    'payroll.workers-compensation.warningBanner.0'
                        | translate: { nextYear: formattedNextYear, endDate: formattedYearEndDate }
                }}</strong
                >&nbsp;{{ 'payroll.workers-compensation.warningBanner.1' | translate }}
            </div></ui-banner
        >
    }

    <app-table [table]="table">
        <div class="empty">
            <img style="max-width: 30%" src="/assets/illustrations/magnifying-glass.png" />
            <h2 class="ui centered header">
                {{ 'payroll.workers-compensation.noWorkersCompensationRatesFound' | appTranslate }}
            </h2>
        </div>
    </app-table>
</div>
